import styles from './SponsoredBadge.module.scss';


export function SponsoredBadge({ link }: { link: string }) {
  return (
    <div className={styles.container}>
      <a className={styles.content} href={link}>
        реклама • adengi.ru
      </a>
    </div>
  );
}
